import React from 'react';
import { DashboardStatusTag } from '../components/dashboard';
import { isOperatorUseBlocked, SERVICE_OVERDUE_MESSAGE } from './operatorDashboardUtils';

export default function OperatorForkliftAvailability({ forklift, compact = false }) {
  const blocked = isOperatorUseBlocked(forklift);

  if (!blocked) {
    return (
      <DashboardStatusTag color="success" className="operator-forklift-status-tag is-available">
        Available
      </DashboardStatusTag>
    );
  }

  return (
    <div className={compact ? 'operator-forklift-status-compact' : undefined}>
      <DashboardStatusTag color="error" className="operator-forklift-status-tag is-unavailable">
        Unavailable
      </DashboardStatusTag>
      <div className="operator-forklift-status-message">{SERVICE_OVERDUE_MESSAGE}</div>
    </div>
  );
}
